import { makeStyles } from 'e100-react-components';

import { IPropTypes } from 'e100-react-components/lib/components/TextField';

interface StyleProps extends Pick<
  IPropTypes,
  'variant'
> {}

export const useStyles = makeStyles(({ palette }) => ({
  root: ({ variant }: StyleProps) => ({
    ...variant === 'outlined' && {
      '& input': {
        backgroundColor: palette.grey[100],
        '&:focus': {
          backgroundColor: 'transparent'
        }
      },
      
      '& fieldset': {
        borderColor: palette.grey[100]
      },

      '&:hover': {
        '& input': {
          backgroundColor: 'transparent',
        },

        '& fieldset': {
          borderColor: palette.primary.main
        }
      },

      '&:focus': {
        '& input': {
          backgroundColor: 'transparent',
        },

        '& fieldset': {
          borderColor: palette.primary.main
        }
      }
    }
  })
}));